"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 0C7.97 0 4.21 2.07 2 5.41V3.43c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.72C5.57 3.69 8.67 2 12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10c-.55 0-1 .45-1 1s.45 1 1 1c6.62 0 12-5.38 12-12S18.62 0 12 0Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 8c-.55 0-1 .45-1 1v4a.395.395 0 0 0 .018.1l.005.018.007.032c.01.07.02.14.04.21a.545.545 0 0 0 .076.134l.041.064a.6.6 0 0 0 .093.132c.05.05.11.09.17.13.013.01.026.02.038.032.024.022.05.045.082.058l3.6 1.75c.5.24 1.1.03 1.34-.46.24-.5.03-1.1-.46-1.34l-3.03-1.48V9.01c0-.55-.45-1-1-1L12 8Z"
  })]
});